import channels from './Channels'
export default [
  {
    id: 1,
    name: 'mono',
    image: 'Sound-computer-over.svg',
    channels: {
      SINGLE: 'single'
    }
  },
  {
    id: 2,
    name: 'stereo',
    image: 'Sound-headphone-over.svg',
    channels
  }
]